import Styled from 'styled-components';

const NoCommentsStyled = Styled.div`
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

const Title = Styled.a`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #575757;
  padding: 16px 16px 8px 16px;
`;

const Text = Styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  padding-bottom: 12px;
  color: #575757;
`;

const HeaderMsg = Styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  padding: 16px;
  color: #575757;
  background: #FAFAFA;
`;

const Anchor = Styled.a`
  display: flex;
  justify-content: center;
  padding-bottom: 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: ${({ theme }) => theme.primaryColor};
`;

export default NoCommentsStyled;
export { NoCommentsStyled, Title, Text, HeaderMsg, Anchor };
